import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";

import { addEntities } from "../../entities";
import {
  FETCH_RECEIVABLES_BY_DEBTORS_FAILURE,
  FETCH_RECEIVABLES_BY_DEBTORS_REQUEST,
  FETCH_RECEIVABLES_BY_DEBTORS_SUCCESS
} from "../types";

const fetchReceivablesByDebtors = (
  ordering,
  limit,
  offset,
  filters = {}
) => async (dispatch, getState, { api, schema }) => {
  try {
    await debounced(dispatch, schema, api, limit, offset, ordering, filters);
  } catch (err) {
    dispatch(createAction(FETCH_RECEIVABLES_BY_DEBTORS_FAILURE)(err));
    throw err;
  }
};

const debounced = debounce(
  async (dispatch, schema, api, limit, offset, ordering, filters) => {
    dispatch(
      createAction(FETCH_RECEIVABLES_BY_DEBTORS_REQUEST)({
        limit,
        offset,
        ordering,
        filters
      })
    );
    const response = await api.debtors.getDebtors(
      undefined,
      ordering,
      limit,
      offset,
      {
        receivables: true,
        ...filters
      }
    );
    const data = normalize(response.results, [schema.debtors]);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_RECEIVABLES_BY_DEBTORS_SUCCESS)({
        items: data.result,
        count: response.count,
        limit,
        offset,
        ordering,
        filters
      })
    );
    return response;
  },
  1000,
  { trailing: true }
);
export default fetchReceivablesByDebtors;
